export var defaultProps = {
    className: '',
    style: undefined,
    type: 'date',
    range: ['', ''],
    defaultValue: '',
    value: '',
    format: 'yyyy-MM-dd',
    disabledItems: [],
    disabled: false,
    showToday: true,
    onBeforeChange: function (value, e) { return true; },
    onChange: function (value, e) { },
    placeholder: '请选择日期',
    double: false,
    hasConfirmBtn: false,
    bordered: true,
    showIcon: true,
    rangeIdx: 0,
    defaultRangeValue: '',
};
export var defaultRangeProps = {
    className: '',
    style: undefined,
    type: 'date',
    range: ['', ''],
    defaultValue: ['', ''],
    value: ['', ''],
    format: 'yyyy-MM-dd',
    disabled: false,
    onBeforeChange: function (value, e) { return true; },
    onChange: function (value, e) { },
    placeholder: ['开始日期', '结束日期'],
    rangeIdx: 1,
};
